import config from '../config';

const apiClient = {
  async request(endpoint, options = {}) {
    const url = `${config.apiUrl}${endpoint}`;
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    });

    // Get the response text first
    const text = await response.text();
    
    // Try to parse as JSON if there's content
    let data;
    try {
      data = text ? JSON.parse(text) : {};
    } catch (e) {
      console.error('Failed to parse response:', e);
      console.error('Response text:', text);
      throw new Error('Invalid response from server');
    }

    if (!response.ok) {
      throw new Error(data.error || 'Request failed');
    }

    return data;
  },

  // Auth endpoints
  async login(email, password) {
    return this.request('/api/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  },

  async requestReset(email) {
    return this.request('/api/request-reset', {
      method: 'POST',
      body: JSON.stringify({ email }),
    });
  },

  async resetPassword(token, password) {
    return this.request('/api/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    });
  },

  async completeSignup(email, password, sessionId) {
    return this.request('/api/complete-signup', {
      method: 'POST',
      body: JSON.stringify({ email, password, sessionId }),
    });
  },

  // URL endpoints
  async shortenUrl(url, token) {
    return this.request('/api/shorten', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      body: JSON.stringify({ url }),
    });
  },

  async shortenFreeUrl(url) {
    return this.request('/api/shorten-free', {
      method: 'POST',
      body: JSON.stringify({ url }),
    });
  },

  async getUserUrls(token) {
    return this.request('/api/user-urls', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async getDashboard(token) {
    return this.request('/api/dashboard', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async updateUrl(shortId, newUrl, token) {
    return this.request(`/api/urls/${shortId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ newUrl })
    });
  },

  async deleteUrl(shortId, token) {
    return this.request(`/api/urls/${shortId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
  },

  // Subscription endpoints
  async getSubscriptionStatus(token) {
    return this.request('/api/subscription/status', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async cancelSubscription(token) {
    return this.request('/api/cancel-subscription', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async resubscribe(token) {
    return this.request('/api/resubscribe', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async getInvoices(token) {
    return this.request('/api/invoices', {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  async verifySubscriptionSuccess(sessionId, token) {
    return this.request(`/api/subscription/success?session_id=${sessionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};

export default apiClient;
